import { LitElement, html, css } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import alertStore from './AlertStore';
import { setAlert } from './AlertSlice';

export class AppTourGuide extends LitElement {
    static styles = css`
        :host {
            display: none;
            position: fixed;
            top: 0; left: 0; width: 100vw; height: 100vh;
            z-index: 99999;
            pointer-events: auto;
        }
        :host([visible]) {
            display: block;
        }

        .spotlight {
            position: absolute;
            border-radius: 12px;
            box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.7), 0 0 15px rgba(0,0,0,0.5) inset;
            pointer-events: none;
            transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
            z-index: 1;
            border: 2px solid rgba(255, 255, 255, 0.8);
        }
        
        .spotlight.center {
            top: 50%; left: 50%;
            width: 0; height: 0;
            box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.7);
            border: none;
        }

        .dialog {
            position: absolute;
            background: white;
            padding: 24px;
            border-radius: 12px;
            box-shadow: 0 10px 40px rgba(0,0,0,0.4);
            z-index: 2;
            transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
            display: flex;
            flex-direction: column;
            gap: 12px;
            opacity: 0;
            animation: fadeIn 0.4s forwards;
            box-sizing: border-box;
        }
        @keyframes fadeIn { to { opacity: 1; } }

        .title { 
            font-size: 1.1rem; 
            font-weight: 900; 
            color: #007bff; 
            margin:0; 
            display:flex; 
            align-items:center; 
            gap:8px;
        }

        .tour-media {
            width: 100%;
            height: auto;
            max-height: 180px;
            object-fit: contain;
            border-radius: 8px;
            border: 1px solid #f0f0f0;
            background-color: #f9f9f9;
            cursor: pointer;
            transition: opacity 0.2s;
        }

        .tour-media:hover {
            opacity: 0.85;
        }

        .mobile-media-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            background: #f0f7ff;
            color: #007bff;
            border: 1px dashed #007bff;
            padding: 8px;
            border-radius: 8px;
            font-weight: bold;
            cursor: pointer;
            transition: all 0.2s;
            font-size: 0.9rem;
        }
        .mobile-media-btn:hover {
            background: #e6f2ff;
        }

        .desc { font-size: 0.95rem; color: #333; line-height: 1.5; margin:0; font-weight: 500;}
        
        /* === Footer Layout === */
        .footer {
            display: flex;
            flex-direction: column; /* 縦並びベースに変更 */
            margin-top: 8px;
            width: 100%;
            gap: 16px; /* ドットとボタンの間隔 */
        }

        .dots { 
            display: flex; 
            gap: 6px; 
            flex-wrap: wrap; 
            justify-content: center;
            width: 100%;
        }
        .dot { width: 8px; height: 8px; border-radius: 50%; background: #d1d5db; transition: 0.3s; flex-shrink: 0;}
        .dot.active { background: #007bff; transform: scale(1.2);}

        .footer-buttons {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            gap: 8px;
        }

        .btn-group-left {
            display: flex;
            gap: 4px;
            align-items: center;
        }

        .btn-group-right {
            display: flex;
            gap: 8px;
            align-items: center;
            justify-content: flex-end;
        }

        button {
            padding: 8px 14px; border: none; border-radius: 6px; font-weight: bold; cursor: pointer; transition: 0.2s; white-space: nowrap; font-size: 0.9rem;
        }
        
        /* 狭い幅でも収まるように、スキップ系ボタンは少しコンパクトに */
        .btn-skip { background: transparent; color: #6b7280; padding: 6px 4px; font-size: 0.85rem; }
        .btn-skip:hover { background: #f3f4f6; color: #111827; }
        
        .btn-next { background: #007bff; color: white; box-shadow: 0 2px 4px rgba(0,123,255,0.3); }
        .btn-next:hover { background: #0056b3; transform: translateY(-1px); }

        .btn-prev {
            background: white;
            border: 1px solid #d1d5db;
            color: #4b5563;
        }
        .btn-prev:hover {
            background: #f3f4f6;
            color: #111827;
        }

        /* メディアモーダル (モバイル表示用 / PCのYouTube用) */
        .media-modal-overlay {
            position: fixed;
            top: 0; left: 0; width: 100vw; height: 100vh;
            background: rgba(0, 0, 0, 0.85);
            z-index: 100000;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            backdrop-filter: blur(5px);
            animation: fadeIn 0.2s ease-out;
        }
        .media-modal-content {
            position: relative;
            width: 95%;
            max-width: 800px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: black;
            border-radius: 8px;
            padding: 5px;
            box-sizing: border-box;
            box-shadow: 0 10px 40px rgba(0,0,0,0.5);
        }
        .media-modal-close {
            position: absolute;
            top: -45px;
            right: 0;
            background: none;
            border: none;
            color: white;
            font-size: 36px;
            line-height: 1;
            padding: 0;
            cursor: pointer;
        }
        .media-modal-content video,
        .media-modal-content iframe,
        .media-modal-content img {
            width: 100%;
            max-height: 80vh;
            aspect-ratio: 16 / 9;
            object-fit: contain;
            border-radius: 4px;
            border: none;
        }
        
        /* モバイル向けにさらにコンパクトに */
        @media (max-width: 480px) {
            .dialog {
                padding: 16px; /* 余白を詰める */
                gap: 8px;
            }
            .title {
                font-size: 1rem;
            }
            .desc {
                font-size: 0.85rem;
            }
            button {
                padding: 6px 12px;
                font-size: 0.85rem;
            }
            .btn-skip {
                padding: 6px 4px;
            }
            .footer {
                flex-direction: column;
                align-items: stretch;
                gap: 12px;
            }
            .btn-group-right {
                width: 100%;
                justify-content: space-between;
            }
            .btn-group-left {
                justify-content: center;
            }
            .btn-next {
                flex: 1;
                text-align: center;
            }
            .btn-skip {
                align-self: flex-start;
            }
            .footer-buttons {
                flex-direction: column;
                align-items: stretch;
                gap: 16px;
            }
        }
    `;

    static properties = {
        visible: { type: Boolean, reflect: true },
        steps: { type: Array },
        currentStep: { type: Number },
        isMobile: { type: Boolean },
        showMediaModal: { type: Boolean },
        _forceRenderTick: { type: Number }
    };

    constructor() {
        super();
        this.visible = false;
        this.steps = [];
        this.currentStep = 0;
        this.isMobile = window.innerWidth <= 768;
        this.showMediaModal = false;
        this._forceRenderTick = 0;

        this._resizeHandler = () => {
            this.isMobile = window.innerWidth <= 768;
            this.requestUpdate();
        };
    }

    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('resize', this._resizeHandler);
        this.addEventListener('click', (e) => e.stopPropagation());
        this.addEventListener('mousedown', (e) => e.stopPropagation());
        this.addEventListener('touchstart', (e) => e.stopPropagation(), { passive: false });
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this._resizeHandler);
        super.disconnectedCallback();
    }

    startTour(steps) {
        if (!steps || steps.length === 0) return;
        this.steps = steps;
        this.currentStep = 0;
        this.showMediaModal = false;
        this.visible = true;
        window.__PWAPPY_TOUR_ACTIVE__ = true;
        this._executeStepHook();
    }

    next() {
        if (this.currentStep < this.steps.length - 1) {
            this.currentStep++;
            this._executeStepHook();
        } else {
            this.endTour();
        }
    }

    prev() {
        if (this.currentStep > 0) {
            this.currentStep--;
            this._executeStepHook();
        }
    }

    _executeStepHook() {
        this.showMediaModal = false;
        const step = this.steps[this.currentStep];
        if (step && typeof step.onShow === 'function') {
            try { step.onShow(); } catch (e) { console.error(e); }
        }
        [50, 200, 500].forEach(delay => {
            setTimeout(() => {
                this._forceRenderTick++;
                this.requestUpdate();
            }, delay);
        });
    }

    endTour() {
        this.visible = false;
        this.showMediaModal = false;
        window.__PWAPPY_TOUR_ACTIVE__ = false;

        localStorage.setItem('pwappy_tour_completed', 'true');

        if (this.steps[this.currentStep] && typeof this.steps[this.currentStep].onEnd === 'function') {
            try { this.steps[this.currentStep].onEnd(); } catch (e) { console.error(e); }
        }
    }

    _calculateStyles() {
        const step = this.steps[this.currentStep];
        if (!step) return { spotlight: {}, dialog: {} };

        if (!step.targetSelector) {
            const dw = Math.min(320, window.innerWidth * 0.9);
            return {
                spotlight: {},
                dialog: { top: '50%', left: '50%', width: `${dw}px`, transform: 'translate(-50%, -50%)' },
                isCenter: true
            };
        }

        let targetEl = null;
        try {
            if (typeof step.targetSelector === 'function') {
                targetEl = step.targetSelector();
            } else if (typeof step.targetSelector === 'string') {
                const root = document.querySelector('app-container')?.shadowRoot;
                if (root) targetEl = root.querySelector(step.targetSelector);
            }
        } catch (e) { console.error(e); }

        if (step.targetSelector === 'platform-container' && targetEl) {
            const osComponent = targetEl.shadowRoot.querySelector('ios-component') || targetEl.shadowRoot.querySelector('android-component');
            if (osComponent && osComponent.shadowRoot) {
                const innerContainer = osComponent.shadowRoot.getElementById('ios-container') || osComponent.shadowRoot.getElementById('android-container') || osComponent.shadowRoot.querySelector('.ios-container') || osComponent.shadowRoot.querySelector('.ios-container-side') || osComponent.shadowRoot.querySelector('.android-container') || osComponent.shadowRoot.querySelector('.android-container-side');
                if (innerContainer) targetEl = innerContainer;
            }
        }

        const targetRect = targetEl ? targetEl.getBoundingClientRect() : null;
        if (!targetEl || (targetRect.width === 0 && targetRect.height === 0)) {
            const dw = Math.min(320, window.innerWidth * 0.9);
            return {
                spotlight: {},
                dialog: { top: '50%', left: '50%', width: `${dw}px`, transform: 'translate(-50%, -50%)' },
                isCenter: true
            };
        }

        const rect = targetRect;
        const padding = 8;
        const spotlight = {
            top: `${rect.top - padding}px`,
            left: `${rect.left - padding}px`,
            width: `${rect.width + padding * 2}px`,
            height: `${rect.height + padding * 2}px`
        };

        const vw = window.innerWidth;
        const vh = window.innerHeight;
        const margin = 15;
        const dw = Math.min(320, vw * 0.9);

        let dh = 200;
        const dialogEl = this.shadowRoot.querySelector('.dialog');
        if (dialogEl && dialogEl.offsetHeight > 0) dh = dialogEl.offsetHeight;

        const spaceTop = rect.top;
        const spaceBottom = vh - rect.bottom;
        const spaceLeft = rect.left;
        const spaceRight = vw - rect.right;

        let top = 0; let left = 0;

        if (vw < 768) {
            left = (vw - dw) / 2;
            if (step.position === 'bottom' || (step.position !== 'top' && spaceBottom >= spaceTop)) {
                top = rect.bottom + padding + margin;
            } else {
                top = rect.top - padding - margin - dh;
            }
        } else {
            if (step.position === 'right' || (step.position !== 'left' && spaceRight >= dw + margin)) {
                left = rect.right + padding + margin;
                top = rect.top;
            } else if (spaceLeft >= dw + margin) {
                left = rect.left - padding - margin - dw;
                top = rect.top;
            } else {
                left = (vw - dw) / 2;
                if (spaceBottom >= spaceTop) {
                    top = rect.bottom + padding + margin;
                } else {
                    top = rect.top - padding - margin - dh;
                }
            }
        }

        if (left < 10) left = 10;
        if (left + dw > vw - 10) left = vw - dw - 10;
        if (top < 10) top = 10;
        if (top + dh > vh - 10) top = vh - dh - 10;

        return {
            spotlight,
            dialog: { top: `${top}px`, left: `${left}px`, width: `${dw}px`, transform: 'none' },
            isCenter: false
        };
    }

    cancelTour() {
        this.visible = false;
        this.showMediaModal = false;
        window.__PWAPPY_TOUR_ACTIVE__ = false;
    }

    /**
   * 単に非表示にするだけで、完了フラグは立てない（次回起動時にまた表示される）
   */
    hideOnly() {
        this.visible = false;
        this.showMediaModal = false;
        window.__PWAPPY_TOUR_ACTIVE__ = false;

        // 案内トースト等を表示
        alertStore.dispatch(setAlert("ツアーを一時中断しました。\n画面下のメニューの「チュートリアル」からいつでも再開できます。"));
    }

    /**
     * ユーザーの明示的な意思で以降非表示にする
     */
    endTourWithNotice() {
        localStorage.setItem('pwappy_tour_completed', 'true');
        this.endTour();
    }

    render() {
        if (!this.visible || this.steps.length === 0) return html``;
        const step = this.steps[this.currentStep];
        const styles = this._calculateStyles();
        const hasMedia = !!(step.video || step.youtubeId || step.image);

        // YouTubeの場合はPC・モバイル問わずモーダルで表示させる
        const needsModalBtn = this.isMobile || !!step.youtubeId;

        return html`
            <div class="spotlight ${styles.isCenter ? 'center' : ''}" style=${styleMap(styles.spotlight)}></div>
            
            <div class="dialog" style=${styleMap(styles.dialog)}>
                <h3 class="title">${step.icon ? html`<i class="fa-solid ${step.icon}"></i>` : ''} ${step.title}</h3>
                
                ${hasMedia ? (
                needsModalBtn ? html`
                        <div class="mobile-media-btn" @click=${() => this.showMediaModal = true}>
                            <i class="fa-brands ${step.youtubeId ? 'fa-youtube' : (step.video ? 'fa-circle-play' : 'fa-image')}"></i>
                            ${step.youtubeId || step.video ? '動画を見る' : '画像を見る'}
                        </div>
                    ` : html`
                        ${step.video ? html`
                            <video class="tour-media" src="${step.video}" autoplay loop muted playsinline @click=${() => this.showMediaModal = true} title="クリックして拡大表示"></video>
                        ` : html`
                            <img class="tour-media" src="${step.image}" alt="Tour guidance image" @click=${() => this.showMediaModal = true} title="クリックして拡大表示">
                        `}
                    `
            ) : ''}
                
                <p class="desc">${step.message}</p>
                
                <div class="footer">
                    <!-- 上段：ドットインジケーター -->
                    <div class="dots">
                        ${this.steps.map((_, i) => html`<div class="dot ${i === this.currentStep ? 'active' : ''}"></div>`)}
                    </div>

                    <!-- 下段：ボタン群 -->
                    <div class="footer-buttons">
                        <div class="btn-group-left">
                            ${this.currentStep === 0 ? html`
                                <button class="btn-skip" @click=${this.endTourWithNotice}>今後表示しない</button>
                                <button class="btn-skip" @click=${this.hideOnly}>後で見る</button>
                            ` : html`
                                <button class="btn-skip" @click=${this.cancelTour}>閉じる</button>
                            `}
                        </div>

                        <div class="btn-group-right">
                            ${this.currentStep > 0 ? html`
                                <button class="btn-prev" @click=${this.prev}>戻る</button>
                            ` : ''}
                            <button class="btn-next" @click=${this.next}>
                                ${this.currentStep === this.steps.length - 1 ? '完了' : '次へ'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            ${this.showMediaModal && hasMedia ? html`
                <div class="media-modal-overlay" @click=${() => this.showMediaModal = false}>
                    <div class="media-modal-content" @click=${e => e.stopPropagation()}>
                        <button class="media-modal-close" @click=${() => this.showMediaModal = false}>&times;</button>
                        ${step.youtubeId ? html`
                            <iframe src="https://www.youtube.com/embed/${step.youtubeId}?autoplay=1&mute=0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                        ` : step.video ? html`
                            <video src="${step.video}" autoplay loop muted playsinline controls></video>
                        ` : html`
                            <img src="${step.image}" alt="Tour guidance image">
                        `}
                    </div>
                </div>
            ` : ''}
        `;
    }
}
customElements.define('app-tour-guide', AppTourGuide);